export function normalizeAthleteSearch(text: string): string {
  return text.normalize('NFKC').replace(/ي/g, 'ی').replace(/ك/g, 'ک')
    .replace(/[\u064b-\u065f\u0670]/g, '').replace(/\u200c/g, ' ')
    .trim().replace(/\s+/g, ' ').toLocaleLowerCase();
}
